import React from 'react';

const LightBulbOutlineIcon = (props) => (
  <svg width='32px' height='32px' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(9.000000, 6.000000)'>
        <path d='M7,0 C10.8659932,0 14,3.13400675 14,7 C14,9.38 12.81,11.47 11,12.74 L11,15 C11,15.5522847 10.5522847,16 10,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,12.74 C1.19,11.47 0,9.38 0,7 C0,3.13400675 3.13400675,0 7,0 M4,19 L4,18 L10,18 L10,19 C10,19.5522847 9.55228475,20 9,20 L5,20 C4.44771525,20 4,19.5522847 4,19 M7,2 C4.23857625,2 2,4.23857625 2,7 C2,9.05 3.23,10.81 5,11.58 L5,14 L9,14 L9,11.58 C10.77,10.81 12,9.05 12,7 C12,4.23857625 9.76142375,2 7,2 L7,2 Z' />
      </g>
    </g>
  </svg>
);

export default LightBulbOutlineIcon;
